import React, { useEffect, useState } from 'react';
import axiosInstance from '../util/axiosConfig';
import useVendorField from '../hooks/useVendorField';
import StockFormModal from './StockFormModal';
import AddVendorModal from './AddVendorModal';
import DisposableForm, {
  emptyDisposableForm,
  disposableFormToPayload,
  validateDisposableForm
} from './DisposableForm';

const AddDisposableModal = ({ open, onClose, onSuccess }) => {
  const [form, setForm] = useState(emptyDisposableForm);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const {
    vendors,
    vendorsLoading,
    addVendorOpen,
    setAddVendorOpen,
    onAddVendor,
    handleVendorCreated
  } = useVendorField(open, (vendorId) => {
    setForm((prev) => ({ ...prev, vendor_id: vendorId }));
  });

  useEffect(() => {
    if (!open) return;
    setForm(emptyDisposableForm());
    setError('');
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const message = validateDisposableForm(form);
    if (message) {
      setError(message);
      return;
    }
    try {
      setSubmitting(true);
      await axiosInstance.post('/disposables', disposableFormToPayload(form));
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add disposable');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <StockFormModal
        open={open}
        onClose={onClose}
        title="Add Disposable"
        error={error}
        onErrorClose={() => setError('')}
      >
        <DisposableForm
          form={form}
          onChange={handleChange}
          onSubmit={handleSubmit}
          loading={submitting}
          vendors={vendors}
          vendorsLoading={vendorsLoading}
          onAddVendor={onAddVendor}
          fullWidthSubmit={false}
        />
      </StockFormModal>
      <AddVendorModal
        open={addVendorOpen}
        onClose={() => setAddVendorOpen(false)}
        onCreated={handleVendorCreated}
      />
    </>
  );
};

export default AddDisposableModal;
